module.exports = __webpack_public_path__ + "static/gustavo-f49dea6e0bcf6e2ff780db820569a6ec.jpg";